export class Answer
{
    private answerText: string;
    private isCorrect: boolean;

    constructor(answerText: string, isCorrect: boolean)
    {
        this.answerText = answerText;
        this.isCorrect = isCorrect;
    }

    public getAnswerText(): string
    {
        return this.answerText;
    }

    public isAnswerCorrect(): boolean
    {
        return this.isCorrect;
    }
}